import React, { useEffect, useState } from "react";
import "./libraryRecommendation.scss";
import { useStaticQuery, graphql } from "gatsby";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

import Slider from "react-slick";
import RecommendationCard from "../../molecules/recommendation-card/recommendationCard";

const LibraryRecommendation = (props: ReferenciaContenido) => {
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);
    const [preparedData, setPreparedData] = useState([]);
    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const CarouselGeneral = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 3,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,   
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    function shuffleArray (arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const r = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[r]] = [arr[r], arr[i]];
        }
        return arr;
    }

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length - 1;

    const data = useStaticQuery(graphql`
        query LIBRARYRECOMMENDATION {
            allContentfulSubcategorias(filter: {contentful_id: {eq: "2SmuRXdJp2FuOoTdiVoL5D"}}) {
            edges {
                node {
                id
                referenciaSubcategorias {
                    referenciaInterna {
                    referenciaContenido {
                        referenciaMultimedia {
                        tituloMultimedia
                        tematica
                        imagenPrincipal {
                            file {
                            url
                            }
                        }
                        categoriaMultimedia
                        }
                        contentful_id
                    }
                    }
                    slug
                }
                }
            }
            }
        }`);
        
        // Data preparation for recommended content
        useEffect(() => {
            const retrievedData = data.allContentfulSubcategorias.edges[0].node.referenciaSubcategorias;
            const dataWithoutSameSlug = retrievedData.filter(item => item.referenciaInterna.referenciaContenido[0].contentful_id != props.contentful_id);
            const filteredData = dataWithoutSameSlug.filter(item => item.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0].categoriaMultimedia == props.referenciaMultimedia[0].categoriaMultimedia);
            const shuffledData = shuffleArray(filteredData).slice(0,6);
            setPreparedData(shuffledData);
        }, []);

        useEffect(() => {
            if (props.filtroTematica) {
                const retrievedData = data.allContentfulSubcategorias.edges[0].node.referenciaSubcategorias;
                const dataWithoutSameSlug = retrievedData.filter(item => item.referenciaInterna.referenciaContenido[0].contentful_id != props.contentful_id);
                const filteredData = dataWithoutSameSlug.filter(item => props.filtroTematica == item.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0].tematica);
                const shuffledData = shuffleArray(filteredData).slice(0,6);
                setPreparedData(shuffledData);
            }
        }, [props.filtroTematica]); 
        
        return(
            <div className={"o-recommendation-section"}>
                <div className="container">
                    <div className="o-recommendation-section__container">
                        <div className="arrows-slider">
                            <div className="arrows-slider-label">
                                <h1>También te puede interesar...</h1>
                            </div>
                            <div className="arrows-slider-arrows">
                            <span
                                className={`arrow icon-chevron-left ${
                                    isActiveBack() ? "active" : ""
                                }`}
                                onClick={goToBack}
                            ></span>
                            <span
                                className={`arrow  icon-chevron-right  ${
                                    isActiveNext() ? "active" : ""
                                }`}
                                onClick={goToNext}
                            ></span>
                            </div>
                        </div>
                        <Slider
                            {...CarouselGeneral}
                            ref={(c) => {
                            setSlider(c);
                        }}
                            >
                        {preparedData.length > 0 && preparedData.map(
                            (item , i) => (
                                <RecommendationCard {...item} key={i} />
                            )
                        )}
                        </Slider>
                    </div>
                </div>
            </div>
        );
      
}

export default LibraryRecommendation;
